import { render, staticRenderFns } from "./AffiliateMainInfoItem.vue?vue&type=template&id=45f9558c&"
import script from "./AffiliateMainInfoItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AffiliateMainInfoItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AffiliateMainInfoItem.vue?vue&type=style&index=0&id=45f9558c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports